<!-- 各类型驾驶证申领数量同环比 -->
<template>
  <div class="proportion">
    <div class="bar-box">
      <div class="bar-box-top">
        <div class="btn" @click="switchClcik(1)" :class="rightTopSwitch == 1?'active':''">同比</div>
        <div class="btn" @click="switchClcik(2)" :class="rightTopSwitch == 2?'active':''">环比</div>
      </div>
      <div id="bar"></div>
    </div>
    <div class="bar-info">
      <div class="bar-info-right">
        <div class="first">
          <div class="first-left">{{chartData.yearAndMonth[0] }}{{chartData.type}}照申领数量</div>
          <div class="first-right">{{chartData.dataList[0]  || 0 | toThousandFilter}}人</div>
        </div>
        <div class="second">
          <div class="second-left">{{chartData.yearAndMonth[1]}}{{chartData.type}}照申领数量</div>
          <div class="second-right">{{chartData.dataList[1]  || 0 | toThousandFilter}}人</div>
        </div>
        <div class="third">
          <div class="third-left">申领数量{{rightTopSwitch == 1 ? '同比' : '环比'}}<span :style="{'color': chartData.ratio >=0 ? 'rgba(95, 255, 151, 1)' : '#ffae0d'}">{{chartData.ratio >=0 ? '增长' : '减少'}}</span></div>
          <div class="third-right">
            <span class="icon" :class="chartData.ratio < 0 ? 'rotate' : ''"></span>
            {{chartData.ratio}}%
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
// const backgourndImg = 'image://data:image/png;base64,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';
// const yellowImg = 'image://data:image/png;base64,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';
// const greenImg = 'image://data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABcAAAAhCAYAAAAyCTAQAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyVpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDYuMC1jMDAzIDExNi5kZGM3YmM0LCAyMDIxLzA4LzE3LTEzOjE4OjM3ICAgICAgICAiPiA8cmRmOlJERiB4bWxuczpyZGY9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkvMDIvMjItcmRmLXN5bnRheC1ucyMiPiA8cmRmOkRlc2NyaXB0aW9uIHJkZjphYm91dD0iIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtbG5zOnhtcE1NPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvbW0vIiB4bWxuczpzdFJlZj0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL3NUeXBlL1Jlc291cmNlUmVmIyIgeG1wOkNyZWF0b3JUb29sPSJBZG9iZSBQaG90b3Nob3AgMjEuMiAoV2luZG93cykiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6NzhBNDBDRTZFMkNCMTFFRkE3MTNBRjAzNDFDRjE4Q0EiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6NzhBNDBDRTdFMkNCMTFFRkE3MTNBRjAzNDFDRjE4Q0EiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDo3OEE0MENFNEUyQ0IxMUVGQTcxM0FGMDM0MUNGMThDQSIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDo3OEE0MENFNUUyQ0IxMUVGQTcxM0FGMDM0MUNGMThDQSIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/Pil+anoAAAdpSURBVHjaZFVrbFxHFf7mPvfh3bU3Wcd27cZ2oZAGmqipSaUISkIpKlJ5U1VUlD6QoBISUlt+gKBI4Q8SVOIXCBQgQKigRagFUdGqpQJCCaUJaZI6GxK39WOzD+/D+7q79zmcmXt3bZddnZ29c2e+853vnDnDjv/+j9j64ZyD06jrBhRNQVDsH+5a3QO9fm8mCDiLxxNriXj8tDIZe1GuLTlQFA2MMbz9ozF1c5L7XC4yDBNByfrCWrHwcH2jcaNl9eD7AYJonWnGkF0du3jN5NQPUiPpnziuJ0m93YEWeOEWwZbRglg8jvYb6z/P/zd/X7PZBLGljUBAPwEt9cXImyiWy3tWCoUf7333ntt2T+++y3Yceh9sA1cEI2meD900YS3Xj7527sx9jVqVPAbSeOAj8MkCLxzJxPpqrY5X/3Pms4VS8ZiqqnBcF67nDU1RFAZhuq7BaPizV65c+lbPsqDRYu4LYJJDOCATzDj35eiTAxFuq2Ph/MXFB3t9+6CQizFlaIrQKiAQk1gXCitfW1peoWzGwcAlqAQWoCSP0EeMgXTIIxkUVNZrKFXWjxoCXFGHpniUDLHIpZAK5fJHmpUylFYNPnnmA2ABOmC/zUFYXa7HUa7WjhD7hEdERYKFKYKZT+aRrldrlnrkXSa+9PE5rJa7cmPIkG/+H0QTBkLxMWndnq3RujldM6CqujTFYh4suHBUoN1wTu29aQ433/shpHVgaa0ZMScCQZR4kcxIFgGqUPk5IrktD50eN3sOh2UH0rRPmu8MazLho3dg55tNWatJfPuRgzj63b8j/9YGuKHKUvWDqICoALKpODJxhg6BjMUCfOX2CbSSsYbn+KKoQ8w5LRkWpevj/o/OouR4gF3Fez44hxPjJp7782XklxqkK7ArHUN6hBLf6OHZs2Us9wM0uxwP3JLF4TvGKbdT+2Fm3oRnh+BwMyE46ZK5NvZ8Zkb7Olp9caJgzI3jzod24M5aD+h5sjIgInM5PrNYxcO/vIAVr4kv3j4LNCm2yWwMyVE6cSE4408Wo/NEmzjZvpMnMaoeGh5bmTUBSHrYfmiBBmSz8K7U0agsI3ddHIjdEGDvrWkEbldqJ5mbzuZ5pfKDrx5D3zsE0XN45IB6jmArpIMfPdf6pOkscgliWW8Bt+z7vCgabGkBGmVnS0sU2vOXYNECM5oLIjCPh+w9JZRHRErO3NG92Mik782lR58Ad4FBI2RClt+UAEMJQQS6YD/9l2cQ9z4GNZoPInAhO6eaVUkGPUVSpMHn3/uqpxsLetj6tjcuqKRfW+hIL3wWhu2qD6BF3zYx6dMEVYU0eoRH612DdpKD7DSYbtytywgZsKUpnsIlKOcPVxCY5NVxQg1c0nBpoYaOdTNK3XMotklTKyRgEUCfmPMEkJosYueuW2nTUkQzNPr8m6byKIC9xF/GqDMGr+OjrfgwqCSTLYZUNYlMMwXWuvQB2PY9cPsLejzupWemzvLpHf/wxzJPshG111ds9OBQwL6UtYAGzuMtjNJB1OJIwzLa6GQd1KSolMtxYveODXR8c3/HSeaWF0udwsXL9biZ6l4/ob9y9/j8L3KKgheURWodPdE/hV6kOLVjehrDiGgMYP/k50ENkhb5JHKADBIooX3bIoqP1WG9v06srpYraLXqCKjns3Qae0bnsU+ZODEF4xs5xFY75IBuWzK+LaHsFIGTD4Kg1gkdl1H+3l+Rf1SHQYEZaFPpuuTel9tF4D4FLmYZrsNE9zB2f/V6jP1UzPhR5MNq4bLYSWPEcRZrv/sTTj/q0qIcyWWjT/9EiQhmoTGaHaMd1xKRdVSST+HMsVew9sMMYjSrSOWDyJSO9KfjXyic+BsufJq6CLnJ0EuHoPrgUlFhgRxFmw2kkMAOAtPJ+bO48NBJrP42SztH6J1J8zEycXtSRdYfeQGv3yOgik0D3Akkaz8CDrsAH3YDwapPIAG5SNCYoPE5XLrrLCo/Gicx6ZqQUSgunbGXsfR9i1K6YSfgVS1kVI4OMRqAhaYMHVAtYcNTse6qBCI6hWDL8Afkv3wOtfvFbJv0UPIoP75CRaiT/0bXxlQqAZP6g1B7O3h4UjYd+CivtWQnFrNxmhH1/iLe+JkHb0rIoyyh+gmx2CZv4m7cOZKk//8vxXZZSA5N3EwcjYYrup/8pojiEuoif78SzhRx6EWN2/RgUJ8ZMbQojQMpBpfwwAELK0FejQZaPVeuY9FXJPM0ykeqsN6n3IjZxzRKwjrBJxIJxOjWtmVlsOHNvumAyc43iMBIxWDRhdyX1RPOm8S+QTPnUHlQm0fuO5/DwurrqH4qbmgzDVT3W7A3L6Ih+60mDjclcURBqdenuyKGXNqQhHzZCDiq6O/SugQ0g9TxOWSOx2jD8wiu5lGaZLTEkBCb7W5wOAYlKuLwd6Xh+CalkmGDfm15IA0cwOSvRSVR2Tlyg5hcwO6bKLRvXkbpjjra87YsySCqFBa1AEZOVVyDmH9wfPq1GzDx9DLaH76C6qER6NUDyD4+jdGn/ifAAEdaJuu49tByAAAAAElFTkSuQmCC';

const backgourndImg = require('@/assets/images/governmentAffairs/vehiclesupervisor/icon_thb_o.png');;
const yellowImg = require('@/assets/images/governmentAffairs/vehiclesupervisor/icon_thb_o_c.png');;
const greenImg = require('@/assets/images/governmentAffairs/vehiclesupervisor/icon_thb_t.png');;

import * as echarts from 'echarts';
import resize from "@/components/chart/mixins/resize";
import { parseTime } from "@/utils/index";
let chartVm = null;
export default {
  mixins: [resize],
  props: {
    // 使用率0、兑付率1
    useSelected: {
      type: Number,
      default: 0,
    },
    // 选择月份
    monthSelected: {
      type: Number,
      default: 0,
    },
    chartData: {
      type: Object,
      default: () => {
        return {
          yearAndMonth: [],
          years: [],
          months: [],
          dataList: [],
          ratio: 0
        }
      }
    }
  },
  data() {
    return {
      chart: null,
      unit: '%',
      // 同比1、环比2
      rightTopSwitch: 1,
      // 立体柱状图颜色 [[黄色、绿色]]
      imgArr: [backgourndImg, yellowImg, greenImg],
      options: {
        // tooltip: {
        //   position: function (pos, params, dom, rect, size) {
        //       // 鼠标在左侧时 tooltip 显示到右侧，鼠标在右侧时 tooltip 显示到左侧。
  
        //       return [pos[0] - 20, '10'];;
        //   },
        //   trigger: "axis",
        //   borderColor: 'rgba(10, 69, 31, 0.8)',
        //   backgroundColor: 'rgba(10, 69, 31, 0.8)',
        //   axisPointer: {
        //     type: "line",
        //     lineStyle: {
        //       type: 'dashed',
        //       width: 1,
        //     },
        //     label: {
        //       color: '#ffffff',
        //       backgroundColor: "rgba(10, 69, 31, 0.8)",
        //     },
        //     axis: 'y'
        //   },
        //   formatter(params) {
        //     let dom = '';
        //     [params[0]].map(v=>{
        //       dom+= `
        //       <div style="background: rgba(0, 81, 28, 0.5);border-radius: 4px;font-size:12px;color: #95FFBA;font-weight:400;line-height:1;">${v.axisValueLabel}</div>`
        //     });
        //     return `<div>${dom}</div>`;
        //   }
        // },
        grid: {
          right: '12px',
          left: "34%",
          top: "1%",
          bottom: "9%"
        },
        xAxis: {
          show: false,
        },
        yAxis: {
          type: "category",
          inverse: true,
          axisTick: { show: false },
          axisLine: { show: false },
          axisLabel: {
            margin: 10,
            padding: [8,0,0,0],
            color: '#BABBBD',
            fontSize: 14
          }
        },
        series: [],
      },
      maxData: 0,
    };
  },
  watch: {
    chartData: {
      deep: true,
      handler(val) {
        this.initChart();
      },
    },
  },
  mounted() {
    this.initChart();
    chartVm = this;
  },
  activated() {
    this.$nextTick(function () {
      setTimeout(() => {
        this.chart.resize();
      }, 500);
    });
  },
  created() {},
  beforeDestroy() {
    if (!this.chart) {
      return;
    }
    this.chart.dispose();
    this.chart = null;
  },
  methods: {
    // 同比1、环比切换2
    switchClcik(type) {
      if(type == 1) {
        this.rightTopSwitch = 1;
      }else {
        this.rightTopSwitch = 2;
      }
      this.$emit('switchClcik', this.rightTopSwitch);
    },
    setChartData() {
      let series = [];
      let that = this;
      let backgroundColor = '';
      let copyDataList = Object.assign([], this.chartData.dataList);
      if (this.chartData.dataList && this.chartData.dataList.length > 0) {
        this.maxData = Math.max(copyDataList[0], copyDataList[1]);
        let num1 = copyDataList[0];
        let num2 = copyDataList[1];
        if(num1 == this.maxData ) {
          if(num1 != 0) {
            if(num2 == 0) {
              copyDataList[0] = 116;
            }else {
              let ratio = +(num2 / num1).toFixed(1);
              copyDataList[0] = 116;
              copyDataList[1] = +(116 * ratio).toFixed(1);
            }
          }
        }else {
          if(num2 != 0) {
            if(num1 == 0) {
              copyDataList[1] = 116;
            }else {
              let ratio = +(num1 / num2).toFixed(1);
              copyDataList[1] = 116;
              copyDataList[0] = +(116 * ratio).toFixed(1);
            }
          }
        }
        series.push({
            type: 'pictorialBar',
            animationDuration: 0,
            symbolRepeat: 'fixed',
            symbolClip: true,
            symbol: function(value, params, dataIndex) {
              return  `image://${that.imgArr[params.dataIndex + 1]}`;
            },
            symbolSize: [23,33],
            symbolMargin: 0,
            data: copyDataList,
            symbolBoundingData: 230,
            z: 11
          }
        )  
        series.push(          
          {
            type: 'pictorialBar',
            symbol: `image://${that.imgArr[0]}`,
            symbolRepeat: 'fixed',
            symbolMargin: 0,
            symbolSize: [23,33],
            data: copyDataList,
            symbolBoundingData: 230,
            // symbolBoundingData: that.maxData,
            z: 10
          }
        );
        this.options.yAxis.data = this.chartData.yearAndMonth;
        this.options.series = series;
        this.chart.setOption(this.options);
      } else {
        this.options.yAxis.data = [];
        this.options.series = [];
        this.chart.setOption(this.options,true); // 设置为true的话，就是notMerge，不合并,false的话，就Merge，之前的东西还保留~
      }

    },
    initChart() {
      if (!this.chart) {
        this.chart = echarts.init(document.getElementById('bar'));
      }
      this.setChartData();
    },
  },
};
</script>

<style lang='scss' scoped>
@function vw($px) {
  @return ($px / 1920) * 100vw;
}
@function vh($px) {
  @return ($px / 1080) * 100vh;
}
@function fontSize($px) {
  @return 100vw * $px / 1920;
}

.proportion {
  display: flex;
  height: 100%;
  .bar-box {
    width: vw(340);
    height: 100%;
    display: flex;
    flex-direction: column;
    .bar-box-top {
      display: flex;
      margin-right: vw(22);
      font-size: fontSize(14);
      color: #92E8B0;
      .btn {
        width: vw(78);
        height: vh(26);
        margin-right: vw(14);
        line-height: vh(24);
        background: url("../../../../assets/images/governmentAffairs/vehiclesupervisor/menu_thb.png") no-repeat;
        background-size: 100% 100%;
        display: flex;
        justify-content: center;
        cursor: pointer;
        &.active {
          font-size: fontSize(14);
          color: #FFFFFF;
          background: url("../../../../assets/images/governmentAffairs/vehiclesupervisor/menu_thb_c.png") no-repeat;
          background-size: 100% 100%;
        }
      }
    }
    #bar {
      width: 100%;
      height: 100%;
    }
  }
  .bar-info {
    flex: 1;
    display: flex;
    justify-content: space-between;
    font-family: Microsoft YaHei;
    margin-top: vh(4);
    margin-left: vh(5);
    .bar-info-right {
      .first {
        display: flex;
        justify-content: center;
        align-items: center;
        .first-left {
          font-size: fontSize(14);
          text-align: left;
          color: #FFFFFF;
          margin-right: vw(10);
          width: vw(136);
        }
        .first-right {
          flex:  1;
          font-size: fontSize(20);
          color: #FFAE0D;
        }
      }
      .second {
        margin-top: vh(8);
        display: flex;
        justify-content: center;
        align-items: center;
        .second-left {
          width: vw(136);
          text-align: left;
          font-size: fontSize(14);
          color: #FFFFFF;
          margin-right: vw(10);
        }
        .second-right {
          flex:  1;
          font-size: fontSize(20);
          color: #5FFF97;
        }
      }
      .third {
        margin-top: vh(8);
        display: flex;

        align-items: center;
        .third-left {
          font-size: fontSize(14);
          color: #FFFFFF;
        }
        .third-right {
          font-size: fontSize(20);
          color: #FFFFFF;
          color: #ffffff;
          .icon {
            display: inline-block;
            width: vw(13);
            height: vh(15);
            margin: 0 vw(14) 0 vw(4);
            background: url("../../../../assets/images/work/icon_arrow_top.png") no-repeat;
            background-size: 100% 100%;
            &.rotate {
              background: url("../../../../assets/images/work/icon_arrow_down.png") no-repeat;
              background-size: 100% 100%;
            }
          }
        }
      }
    }

  }
}



</style>
